import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate',
})
export class TruncatePipe implements PipeTransform {
  /**
   * return a string with ellipsis
   * for example for middle type : Lorem ipsum...sit amet.
   * for example for end type: Lorem ipsum dolor...
   * for example for start type: ...dolor sit amet
   * @param {string} value
   * @param {number} limit
   * @param {"start" | "middle" | "end"} type
   * @param {"..."} trail
   * @returns {string}
   */
  transform(
    value: string,
    limit = 100,
    type: 'start' | 'middle' | 'end' = 'end',
    trail = '...',
  ): any {
    if (value) {
      switch (type) {
        case 'start':
          {
            return this.startCrop(value, limit, trail);
          }
          break;
        case 'end':
          {
            return this.endCrop(value, limit, trail);
          }
          break;
        case 'middle':
          {
            return this.middleCrop(value, limit, trail);
          }
          break;
      }
    }
    return null;
  }

  private middleCrop(value: string, limit: number, trail: string) {
    if (value.length > limit + 1) {
      const middle = Math.round((limit - trail.length) / 2);
      return value.substr(0, middle) + trail + value.substr(value.length - middle, value.length);
    }
    return value;
  }

  private endCrop(value: string, limit: number, trail: string) {
    return value.length > limit ? value.substr(0, limit) + trail : value;
  }

  private startCrop(value: string, limit: number, trail: string) {
    return value.length > limit ? trail + value.substr(value.length - limit, value.length) : value;
  }
}
